import { DataClassName } from '@/Data/const'

export const getDeleteModalSubtitle: (dataClassName: string) => string = (
  dataClassName,
) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return 'pages.activity.delete.modal.subtitle'
    case DataClassName.COMPANY:
      return 'pages.company.delete.modal.subtitle'
    case DataClassName.DOCUMENT:
      return 'pages.document.delete.modal.subtitle'
    case DataClassName.GLOBAL_RESULT:
      return ''
    case DataClassName.LEAD:
      return 'pages.lead.delete.modal.subtitle'
    case DataClassName.LIST:
      return 'pages.list.delete.modal.subtitle'
    case DataClassName.OPPORTUNITY:
      return 'pages.opportunity.delete.modal.subtitle'
    case DataClassName.ORDER:
      return 'pages.order.delete.modal.subtitle'
    case DataClassName.PERSON:
      return 'pages.person.delete.modal.subtitle'
    case DataClassName.QUOTE:
      return 'pages.quote.delete.modal.subtitle'
    case DataClassName.TICKET:
      return 'pages.ticket.delete.modal.subtitle'
    default:
      console.warn(`No delete modal subtitle found for ${dataClassName}`)
      return ''
  }
}
